import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { queryClient } from '@/lib/queryClient';
import axiosClient from '@/lib/axiosClient';

export function TokenHandler() {
  const [path, navigate] = useLocation();

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token);
      axiosClient.defaults.headers.common.Authorization = `Bearer ${token}`;
      queryClient.invalidateQueries({ queryKey: ['user'] });
      url.searchParams.delete('token');
      navigate(url.pathname + url.search, { replace: true });
    }
  }, [path, navigate]);

  return null;
}
